export function getFilterOptions(t: (key: string) => string) {
  return [
    { value: 'all', label: t('common.all') },
    { value: 'scheduled', label: t('shipments.scheduled') },
    { value: 'loading', label: t('shipments.loading') },
    { value: 'delivered', label: t('shipments.delivered') },
  ]
}
